import { render, staticRenderFns } from "./showtext.vue?vue&type=template&id=7222b518&scoped=true&"
import script from "./showtext.vue?vue&type=script&lang=js&"
export * from "./showtext.vue?vue&type=script&lang=js&"
import style0 from "./showtext.vue?vue&type=style&index=0&id=7222b518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7222b518",
  null
  
)

export default component.exports